export const Config = {
  REACT_APP_CLOUD_IMAGES:
    "https://mg-show-assets.s3.us-east-1.amazonaws.com/images/user-images/"
};
